import { ref } from 'vue';
/**
 * @returns {{ showPros: import('vue').Ref<boolean>, loader: Function }}
 */
export default function useProsLoader() {
  const showPros = ref(true);
  /**
  * @param {boolean} loaded
  */
  const loader = (loaded) => {
    showPros.value = loaded;
  };

  return {
    showPros,
    loader,
  };
}
